export default __webpack_public_path__ + "static/media/2.79ab770a.png";